module.exports = __webpack_public_path__ + "img/visa.bac487c0.png";